<template>
  <v-container class="pb-10">
    <WithdrawCase
      :value="showWithdrawalTypeModal"
      @onCaseSelected="handleCaseSelected"
      @input="showWithdrawalTypeModal = $event"
    />

    <CryptoAssetModal
      :value="modalDetails.showModal"
      :action-text="{ t1: modalDetails.actionT1, t2: modalDetails.actionT2 }"
      :modal-type="modalDetails.modalType"
      :data-to-use="modalDetails.dataToUse"
      @asset-clicked="handleAssetSelectFromModal"
      @deposit-type-changed="handleModalTypeChange"
      @input="modalDetails.showModal = $event"
    />

    <ServiceUnavailableModal
      :value="showServiceUnavailable"
      :action="restrictedAction"
      @input="showServiceUnavailable = $event"
    />

    <!-- Header -->
    <v-card
      class="mb-6 shadow-lg bg-white rounded-2xl px-8 py-6 flex flex-col md:flex-row items-center justify-between w-full"
      flat
    >
      <div class="flex flex-col items-start w-full md:w-auto">
        <div class="font-bold text-lg capitalize text-gray-900">
          Hello, {{ user.fname | capitalize }}
        </div>
        <div class="text-sm text-gray-500 truncate">
          Welcome to your dashboard
        </div>
      </div>

      <div
        class="grid grid-cols-2 gap-2 mt-4 md:mt-0 w-full md:w-auto md:flex md:flex-wrap md:justify-end"
      >
        <v-btn
          v-for="menu in menus"
          :key="menu.title"
          color="primary"
          @click="handleSelectedAction(menu.value)"
          depressed
          :rounded="true"
          elevation="0"
          class="uppercase font-semibold tracking-wide w-full md:w-auto md:px-6"
        >
          <v-icon left class="text-white">{{ menu.icon }}</v-icon>
          {{ menu.title }}
        </v-btn>
      </div>
    </v-card>

    <div class="flex flex-col lg:flex-row gap-4 lg:gap-8">
      <div class="w-full lg:w-8/12 min-w-0">
        <!-- Banner Top -->
        <div class="" v-if="bannerAnnouncements.length > 0">
          <v-carousel
            v-model="model"
            :show-arrows="false"
            hide-delimiters
            :cycle="true"
            height="120px"
          >
            <v-carousel-item
              v-for="banner in bannerAnnouncements"
              :key="banner._id"
            >
              <v-img
                :src="banner.image"
                height="120px"
                cover
                class="rounded-lg"
              />
            </v-carousel-item>
          </v-carousel>
        </div>
        <!-- Referral Banner -->

        <!-- Asset List Card -->
        <CryptoListing />

        <!-- Banner Bottom -->
        <div class="" v-if="bannerAnnouncements.length > 0">
          <v-carousel
            v-model="model"
            :show-arrows="false"
            hide-delimiters
            :cycle="true"
            height="120px"
          >
            <v-carousel-item
              v-for="banner in bannerAnnouncements"
              :key="banner._id"
            >
              <v-img
                :src="banner.image"
                height="120px"
                cover
                class="rounded-lg"
              />
            </v-carousel-item>
          </v-carousel>
        </div>
      </div>
      <div class="w-full lg:w-4/12 min-w-0">
        <!-- User + announcement card -->
        <v-card
          class="dashboard-user-card rounded-2xl mb-6"
          elevation="2"
          outlined
        >
          <v-card-text class="pa-5">
            <div class="d-flex align-start">
              <div class="dashboard-sidebar-avatar flex-shrink-0">
                <span class="dashboard-sidebar-avatar-initials">
                  {{
                    (user.fname && user.fname[0] ? user.fname[0] : '') +
                    (user.lname && user.lname[0] ? user.lname[0] : '')
                  }}
                </span>
              </div>
              <div class="flex-grow-1 min-w-0 ml-3">
                <div
                  class="d-flex align-center justify-space-between flex-wrap gap-2"
                >
                  <div
                    class="text-h6 font-weight-bold grey--text text--darken-3 text-capitalize text-truncate"
                  >
                    {{ dashboardDisplayName }}
                  </div>
                  <v-chip
                    small
                    label
                    class="dashboard-sidebar-rank-chip flex-shrink-0"
                    @click="$store.commit('user/toggleRankDialog')"
                  >
                    {{ dashboardRankLabel }}
                  </v-chip>
                </div>
                <div
                  v-if="user.username"
                  class="text-body-2 mt-1 dashboard-sidebar-username"
                >
                  @{{ user.username }}
                </div>
              </div>
            </div>

            <template v-if="hasDashboardAnnouncement">
              <v-divider class="my-4"></v-divider>
              <div class="dashboard-announcement-preview rounded-lg pa-4">
                <div
                  v-if="announcementHeading"
                  class="d-flex align-center mb-2"
                >
                  <v-icon small color="primary" class="mr-2"
                    >mdi-bullhorn-outline</v-icon
                  >
                  <span
                    class="text-caption font-weight-bold primary--text text-uppercase letter-spacing-1"
                  >
                    {{ announcementHeading }}
                  </span>
                </div>
                <v-img
                  v-if="popupAnnouncement.image"
                  :src="popupAnnouncement.image"
                  alt=""
                  height="88"
                  cover
                  class="rounded-lg mb-3"
                />
                <div
                  class="dashboard-announcement-body text-body-2 grey--text text--darken-2"
                  v-html="popupAnnouncement.message"
                />
                <v-btn
                  v-if="showAnnouncementButton"
                  color="primary"
                  depressed
                  small
                  block
                  class="mt-3 text-none"
                  :href="popupAnnouncement.buttonLink"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ popupAnnouncement.buttonText }}
                </v-btn>
              </div>
            </template>
          </v-card-text>
        </v-card>

        <!-- Leaderboard Card -->
        <div class="p-6 mb-6 w-full hidden">
          <div class="flex items-center justify-between mb-2">
            <div class="font-bold text-lg text-gray-900">Leader Board</div>
            <div class="flex items-center gap-2 text-gray-400 text-sm">
              <span>2025-05-01</span>
              <v-icon small>mdi-filter-variant</v-icon>
            </div>
          </div>
          <div class="flex gap-2 mb-4">
            <v-btn
              class="bg-yellow-400 text-yellow-900 rounded-lg font-semibold px-4 py-1"
              elevation="0"
              >GIFT CARD</v-btn
            >
            <v-btn
              class="bg-gray-100 text-gray-700 rounded-lg font-semibold px-4 py-1"
              elevation="0"
              >CRYPTO</v-btn
            >
          </div>
          <div class="flex flex-col gap-2">
            <div
              v-for="(entry, i) in [
                { name: 'Timidtimi3', points: '100,000', rank: 1 },
                { name: 'Timidtimi3', points: '100,000', rank: 2 },
                { name: 'Timidtimi3', points: '100,000', rank: 3 }
              ]"
              :key="i"
              class="flex items-center bg-gray-50 rounded-lg px-3 py-2"
            >
              <div
                class="bg-indigo-700 rounded-full w-8 h-8 flex items-center justify-center text-white text-base font-bold mr-3"
              >
                TE
              </div>
              <div class="flex-1">
                <div class="font-semibold text-gray-900">{{ entry.name }}</div>
                <div class="text-xs text-gray-400">
                  {{ entry.points }} points
                </div>
              </div>
              <div
                class="bg-yellow-200 text-yellow-900 rounded-full w-7 h-7 flex items-center justify-center font-bold"
              >
                {{ entry.rank }}
              </div>
            </div>
          </div>
        </div>

        <!-- KYC and Email Card -->
        <!-- <div class="p-6 mb-6 flex flex-col gap-4 w-full">
          <div class="flex items-center gap-2">
            <v-icon class="text-yellow-500">mdi-account-alert</v-icon>
            <span class="font-semibold text-gray-900">Finish your KYC</span>
          </div>
          <v-btn
            class="bg-yellow-400 text-yellow-900 rounded-lg font-semibold px-4 py-2 w-full"
            elevation="0"
            >FINISH KYC NOW! <v-icon right>mdi-chevron-right</v-icon></v-btn
          >
          <div class="flex items-center gap-2 mt-2">
            <v-icon class="text-green-500">mdi-check-circle</v-icon>
            <span class="text-gray-700">Confirm your email</span>
          </div>
          <div class="flex items-center gap-2">
            <v-icon class="text-gray-400">mdi-shield-account</v-icon>
            <span class="text-gray-700">KYC</span>
          </div>
        </div> -->
      </div>
    </div>

    <v-overlay
      v-model="inAppNotification"
      opacity="0.8"
      v-if="popupAnnouncement"
    >
      <v-dialog max-width="700" v-model="inAppNotification">
        <v-card v-if="popupAnnouncement">
          <v-container>
            <div class="flex items-center justify-end">
              <v-icon @click="closeAnnouncement"> mdi-close</v-icon>
            </div>
            <div class="py-2 text-center">
              <div class="text-2xl font-semibold">
                {{ popupAnnouncement.title }}
              </div>
              <div class="my-2 w-full h-auto">
                <img
                  v-if="popupAnnouncement.image"
                  :src="popupAnnouncement.image"
                  alt="announcement"
                  class="w-full h-auto"
                />
              </div>
              <div class="py-2" v-html="popupAnnouncement.message"></div>
              <div v-if="showAnnouncementButton" class="pt-8">
                <v-btn
                  color="primary"
                  depressed
                  size="lg"
                  :href="popupAnnouncement.buttonLink"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ popupAnnouncement.buttonText }}
                </v-btn>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
    </v-overlay>
  </v-container>
</template>

<script>
// import Statistics from '../../components/dashboard/statistics'
// import profileStatus from '../../components/dashboard/profileStatus'
// import MiniCards from '../../components/dashboard/cards/miniCards.vue'
// import NoTransaction from '../../components/noTransaction.vue'

import referralImage from '../../assets/img/referral-image.png'
import card from '../../assets/img/cards.341766b6.png'
import cryto from '../../assets/img/cryto.png'
import PayBillImage from '../../assets/img/pay-your-bills.jpeg'
import AirtimeToCashImage from '../../assets/img/airtime-to-cash.jpeg'

import noData from '../../assets/img/no_data.svg'
import paidTrans from '../../assets/img/paid-trans.svg'
import pending from '../../assets/img/pending-trans.svg'
import wallet from '../../assets/img/wallet-stat.svg'
import decline from '../../assets/img/declined-trans.svg'

import { mapState } from 'vuex'
import transactionApi from '../../api/users/transactions'
import profileApi from '../../api/users/profile'
import { numberWithCommas, updateWallet } from '../../utils/helpers'

import dataApi from '../../api/systemData'
import { COUNTRIES } from '../../utils/countryHelpers'
import CryptoListing from '../../components/dashboard/cryptoListing.vue'
import announcement from '../../api/announcement'
import {
  dismissAnnouncement,
  isAnnouncementDismissed
} from '../../utils/announcementDismissal'
import rank from '../../api/users/rank'

import CryptoAssetModal from '../../components/CryptoAssetModal.vue'
import WithdrawCase from '../../components/WithdrawCase.vue'
import ServiceUnavailableModal from '../../components/ServiceUnavailableModal.vue'
import { isTradeRestricted } from '../../utils/tradeRestriction'

export default {
  components: {
    // Statistics,
    // profileStatus,
    // MiniCards,
    // NoTransaction,
    // Leaderboards
    WithdrawCase,
    CryptoListing,
    CryptoAssetModal,
    ServiceUnavailableModal
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      wallet: (state) => state.user.wallet,
      siteData: (state) => state.user.siteSettings
    }),

    userId() {
      return (this.user && (this.user._id || this.user.id)) || ''
    },

    menus() {
      return [
        {
          title: 'Deposit',
          icon: 'mdi-wallet-plus',
          href: '/user/wallet/wallet',
          value: 'deposit',
          disabled: ''
        },
        {
          title: 'Swap',
          icon: 'mdi-swap-horizontal',
          href: '/user/products/swap',
          value: 'swap',
          disabled: [COUNTRIES.GH, COUNTRIES.KE]
        },
        {
          title: 'Giftcards',
          icon: 'mdi-wallet-giftcard',
          href: '/user/products/giftcards',
          value: 'giftcard',
          disabled: ''
        },
        {
          title: 'Withdraw',
          icon: 'mdi-bank-transfer-out',
          href: '/user/wallet/withdraw',
          value: 'withdraw',
          disabled: [COUNTRIES.GH, COUNTRIES.KE],
          status: this.siteData.airtimeToCashFeatureAvailable
        }
      ]
    },

    cards() {
      return [
        {
          image: card,
          title: 'Giftcards',
          href: '/user/products/giftcards',
          btnTitle: 'Sell Now',
          disabled: [],
          status: true
        },
        {
          image: cryto,
          title: 'Cryptocurrency',
          href: '/user/products/crypto',
          disabled: [],
          status: true
        },
        {
          image: PayBillImage,
          title: 'Pay Bills',
          href: '/user/products/bill-payment',
          btnTitle: 'Pay Now',
          disabled: [COUNTRIES.GH, COUNTRIES.KE],
          status: true
        },
        {
          image: AirtimeToCashImage,
          title: 'Airtime to Cash',
          href: '/user/products/bills/convert-airtime/',
          btnTitle: 'Convert Now',
          disabled: [COUNTRIES.GH, COUNTRIES.KE],
          status: this.siteData.airtimeToCashFeatureAvailable,
          message: this.siteData.airtimeToCashFeatureMessage
        }
      ]
    },

    profileComplete() {
      return !!this.user.email_verify + this.user.kycverify
    },

    statistics() {
      if (this.transactions) {
        return [
          {
            title: 'Pending Transactions',
            count: this.transactions.filter((t) => t.status === 'pending')
              .length,
            icon: pending
          },
          {
            title: 'Paid Transactions',
            count: this.transactions.filter((t) => t.status === 'approved')
              .length,
            icon: paidTrans
          },
          {
            title: 'Declined Transactions',
            count: this.transactions.filter((t) => t.status === 'declined')
              .length,
            icon: decline
          },
          {
            title: 'Amount in Wallet',
            count: numberWithCommas(this.wallet.balance) || 0,
            icon: wallet
          }
        ]
      }
      return []
    },

    showAnnouncementButton() {
      const a = this.popupAnnouncement
      if (!a || Array.isArray(a)) return false
      const text = String(a.buttonText || '').trim()
      const link = String(a.buttonLink || '').trim()
      return text.length > 0 && link.length > 0
    },

    dashboardRankLabel() {
      return this.currentRank && this.currentRank.title
        ? this.currentRank.title
        : 'Rookie'
    },

    dashboardDisplayName() {
      const u = this.user
      if (u.fname && String(u.fname).trim()) return u.fname
      if (u.username) return u.username
      return 'Member'
    },

    hasDashboardAnnouncement() {
      const a = this.popupAnnouncement
      if (!a || Array.isArray(a)) return false
      const msg = String(a.message || '').trim()
      const title = String(a.title || '').trim()
      return Boolean(msg || title || a.image)
    },

    announcementHeading() {
      if (!this.popupAnnouncement || Array.isArray(this.popupAnnouncement))
        return ''
      return String(this.popupAnnouncement.title || '').trim()
    }
  },
  created() {
    this.getTransactions()
    this.getAnnouncements()
    this.getCurrentRank()
    updateWallet()
    this.$store.dispatch('user/getSiteSettings')
  },
  async mounted() {
    const profile = await profileApi.profile().get()

    this.$store.commit('user/updateUserData', profile.data.data)
  },
  methods: {
    // Closing a popup keeps it closed on this device - the key carries the
    // announcement's updatedAt, so an edited one shows again.
    closeAnnouncement() {
      this.inAppNotification = false
      dismissAnnouncement(this.userId, this.popupAnnouncement, this.popupList)
    },
    handleCaseSelected(caseType) {
      this.withdrawCase = caseType
      this.showWithdrawalTypeModal = false
      if (this.withdrawCase === 'snappy_exchange_username') {
        if (this.modalDetails.selectedType === 'fiat') {
          this.$router.push('/user/wallet/transfer')
        }
        if (this.modalDetails.selectedType === 'crypto') {
          this.$router.push(
            `/user/products/crypto/auto-trade/${this.modalDetails.selectedAsset.coinId}/withdraw?type=crypto&case=snappy_exchange_username`
          )
        }
      }

      if (this.withdrawCase === 'external_wallet') {
        if (this.modalDetails.selectedType === 'fiat') {
          this.$router.push('/user/wallet/withdraw')
        }

        if (this.modalDetails.selectedType === 'crypto') {
          this.$router.push(
            `/user/products/crypto/auto-trade/${this.modalDetails.selectedAsset.coinId}/withdraw?type=crypto&case=external_wallet`
          )
        }
      }
    },
    // Fiat withdrawal has one asset (NGNX) and one destination, so skip the
    // asset picker and withdrawal-case modal entirely.
    handleModalTypeChange(type) {
      if (this.modalDetails.action === 'withdraw' && type === 'fiat') {
        this.modalDetails.showModal = false
        this.$router.push('/user/wallet/withdraw')
      }
    },
    handleAssetSelectFromModal(asset, type) {
      // TEMPORARY: auto-processed coins are naira trades - see
      // utils/tradeRestriction.js
      if (asset.hasAutoProcessing && isTradeRestricted(this.userCountry)) {
        this.modalDetails.showModal = false
        this.restrictedAction = this.modalDetails.action
        this.showServiceUnavailable = true
        return
      }

      if (this.modalDetails.action === 'deposit') {
        switch (type) {
          case 'crypto':
            this.$router.push(
              asset.hasAutoProcessing
                ? `/user/products/crypto/auto-trade/${asset.coinId}/deposit`
                : `/user/products/crypto/trade/${asset.coinId}`
            )
            break
          case 'fiat':
            this.$router.push(
              `/user/products/crypto/fiat/${asset.symbol}/deposit`
            )
            break
          default:
            break
        }
      }

      if (this.modalDetails.action === 'withdraw') {
        this.modalDetails.showModal = false
        this.modalDetails.selectedType = type
        this.modalDetails.selectedAsset = asset
        this.showWithdrawalTypeModal = true
      }

      if (this.modalDetails.action === 'swap') {
        if (type === 'fiat') {
          this.$router.push('/user/products/crypto/auto-trade/ngnx/swap?from=ngnx')
          return
        }
        this.$router.push(
          asset.hasAutoProcessing
            ? `/user/products/crypto/auto-trade/${asset.coinId}/swap`
            : `/user/products/crypto/trade/${asset.coinId}`
        )
      }
    },
    handleSelectedAction(action) {
      switch (action) {
        case 'deposit':
          this.modalDetails = {
            showModal: true,
            modalType: 'crypto',
            dataToUse: 'wallets',
            actionT1: 'Deposit Crypto',
            actionT2: 'Deposit Fiat',
            action
          }
          break
        case 'withdraw':
          this.modalDetails = {
            showModal: true,
            modalType: 'crypto',
            dataToUse: 'wallets',
            actionT1: 'Withdraw Crypto',
            actionT2: 'Withdraw Fiat',
            action
          }
          break
        case 'swap':
          this.modalDetails = {
            showModal: true,
            modalType: 'crypto',
            dataToUse: 'wallets',
            actionT1: 'Swap Crypto',
            actionT2: 'Buy with Naira',
            action
          }
          break
        case 'giftcard':
          this.$router.push('/user/products/giftcards')
          break
        default:
          break
      }
    },

    async getData() {
      const res = await dataApi.data().siteSettings('user')
      this.data = res.data.data
    },

    async getTransactions() {
      const res = await transactionApi.transactions().getAll([], 3)
      this.transactions = res.data.data.data
        .map((d) => ({
          ...d,
          date: new Date(
            d.created_at ? d.created_at : d.createdAt
          ).toDateString(),
          type: d.type,
          amount: {
            price: numberWithCommas(d.main_amo),
            currency: d.currencyCode
          },
          status: d.status
        }))
        .slice(0, 4)
    },
    async getAnnouncements() {
      const [popupRes, bannerRes] = await Promise.all([
        announcement.announcement().getCurrent('popup'),
        announcement.announcement().getCurrent('banner')
      ])
      const popupList = popupRes?.data?.data?.data ?? []
      this.popupList = popupList

      // Open the modal on the first popup this user hasn't already closed on
      // this device. The dashboard's inline preview still renders the latest
      // one either way - only the modal is suppressed.
      const firstUnseen = popupList.find(
        (item) => !isAnnouncementDismissed(this.userId, item)
      )
      this.popupAnnouncement = firstUnseen || popupList[0] || null
      this.inAppNotification = !!firstUnseen
      this.bannerAnnouncements = (
        bannerRes?.data?.data?.data ?? []
      ).filter((item) => Boolean(item.image))
    },

    async getCurrentRank() {
      const res = await rank.rankApi().getUserCurrentRank()
      if (res.error) return
      this.currentRank = res.data.data.currentRank
    }
  },

  filters: {
    capitalize: (value) => {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    }
  },

  data: () => ({
    numberWithCommas,
    inAppNotification: false,
    popupList: [],
    transactions: [],
    showWithdrawalTypeModal: false,
    showServiceUnavailable: false,
    restrictedAction: 'trade',
    noData,
    referralImage,
    // card,
    model: null,
    modalDetails: {
      showModal: false,
      modalType: 'crypto',
      dataToUse: 'wallets',
      actionT1: 'Deposit Crypto',
      actionT2: 'Deposit Fiat'
    },
    headers: [
      {
        text: 'Type',
        value: 'type'
      },
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Amount',
        value: 'amount'
      },
      {
        text: 'Status',
        value: 'status'
      }
    ],
    popupAnnouncement: null,
    bannerAnnouncements: [],
    currentRank: null
  })
}
</script>

<style>
.dashboard-header-card {
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 24px 0 rgba(20, 0, 200, 0.06);
  padding: 24px 32px;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
}
.dashboard-header-avatar {
  background: #5a35f7;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 24px;
  font-size: 2rem;
  font-weight: bold;
  color: #fff;
}
.dashboard-header-initials {
  color: #fff;
  font-size: 2rem;
  font-weight: bold;
}
.dashboard-header-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.dashboard-header-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: #222;
}
.dashboard-header-email {
  font-size: 1rem;
  color: #888;
  margin-bottom: 6px;
}
.dashboard-header-badge {
  background: #ffe082;
  color: #7a5d00;
  border-radius: 20px;
  padding: 4px 16px;
  font-size: 1rem;
  font-weight: 500;
  display: inline-block;
  margin-top: 4px;
}
.dashboard-header-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.dashboard-header-action-btn {
  font-weight: 600;
  border-radius: 16px !important;
  min-width: 120px;
  background: #f5f7fa;
  color: #1400c8 !important;
  border: 1px solid #1400c8 !important;
  transition: background 0.2s, color 0.2s;
}
.dashboard-header-action-btn .v-icon {
  color: #1400c8 !important;
}
.dashboard-header-action-btn:hover {
  background: #1400c8 !important;
  color: #fff !important;
}
.dashboard-header-action-btn:hover .v-icon {
  color: #fff !important;
}

.dashboard-user-card {
  border-color: rgba(20, 0, 200, 0.08) !important;
  box-shadow: 0 4px 24px 0 rgba(20, 0, 200, 0.06) !important;
}

.dashboard-sidebar-avatar {
  background: #5a35f7;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-sidebar-avatar-initials {
  color: #fff;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1;
}

.dashboard-sidebar-username {
  color: #5c6bc0;
  font-weight: 500;
  word-break: break-word;
}

.dashboard-sidebar-rank-chip {
  background: #fff3c4 !important;
  color: #7a5d00 !important;
  font-weight: 600 !important;
  border: 1px solid rgba(122, 93, 0, 0.2) !important;
}

.dashboard-announcement-preview {
  background: linear-gradient(180deg, #f8f9ff 0%, #f4f6fb 100%);
  border: 1px solid rgba(90, 53, 247, 0.08);
}

.dashboard-announcement-body {
  line-height: 1.55;
}

.dashboard-announcement-body p {
  margin-bottom: 0.5em;
}

.dashboard-announcement-body p:last-child {
  margin-bottom: 0;
}
</style>
